<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12">
      <v-row align="center">
        <v-col cols="12" class="text-right" >
          <v-dialog v-model="dialog" max-width="445">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                      v-bind="attrs"
                      v-on="on"
                      @click="gift = cloneGift"
              >
                Добавить
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ gift.id ? 'Редактировать подарок' : 'Создать подарок'}}</span>
              </v-card-title>
              <v-card-text>
                  <v-text-field label="Сумма" suffix="UAH" outlined v-model="gift.sum"></v-text-field>
                <v-autocomplete
                        v-model="gift.product"
                        :items="entries"
                        :loading="isLoading"
                        :search-input.sync="search"
                        hide-no-data
                        hide-selected
                        item-text="name"
                        item-value="id"
                        label="Блюдо"
                        outlined
                        return-object
                ></v-autocomplete>
                <v-checkbox
                    v-model="gift.is_active"
                    label="Активен"
                ></v-checkbox>
              </v-card-text>
              <v-card-actions>
                <v-btn v-if="gift.id" @click="updateGift(gift); dialog = false" :loading="loadingModal">Сохранить</v-btn>
                <v-btn v-else @click="createGift(); dialog = false" :loading="loadingModal">Добавить</v-btn>
                <v-btn outlined @click="dialog = false">Отменить</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
      <v-data-table
              no-data-text="Нет подарков"
              no-results-text="По заданному запросу ничего не найдено"
              :headers="headers"
              :items="gifts"
              :options.sync="options"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :footer-props="footerProps"
              :loading="loading"
              loading-text="Загрузка подарков... Подождите пожалуйста"
      >
        <template v-slot:item.sum="{ item }">
          <v-text-field hide-details outlined v-model="item.sum" dense suffix="UAH" @change="updateGift(item  )"></v-text-field>
        </template>
        <template v-slot:item.product.name="{ item }">
          {{ item.product ? item.product.name : '' }}
        </template>
        <template v-slot:item.is_active="{ item }">
          <v-simple-checkbox disabled v-model="item.is_active"></v-simple-checkbox>
        </template>

        <template v-slot:item.actions="{ item }">
          <div class="text-right">
            <v-menu offset-y left>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                        small
                        class="mr-2"
                        v-bind="attrs"
                        v-on="on"
                >
                  mdi-dots-vertical
                </v-icon>
              </template>
              <v-list>
                <v-list-item @click="dialog = true; gift = item">
                  <v-list-item-title>Редактировать</v-list-item-title>
                </v-list-item>
                <v-list-item @click="submitDialog = true; submitItem = item">
                  <v-list-item-title>Удалить</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
      <!--</v-card>-->
    </v-col>
    <v-overlay
            :z-index="4"
            :value="overlay"
    >
    </v-overlay>
    <v-dialog
            v-model="submitDialog"
            max-width="444"
    >
      <v-card>
        <v-card-title >
          Подтвердить действие
        </v-card-title>

        <v-card-actions>


          <v-btn
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  outlined
                  @click="submitDialog = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
    // @ is an alias to /src

    import SaleService from "../../api/SaleService";
    import ProductService from "../../api/ProductService";

    export default {
        name: 'Gift',
        components: {},
        data: () => ({
            search: '',
            isLoading: false,
            submitDialog: false,
            submitItem: null,
            overlay: false,
            loadingModal: false,
            loading: true,
            tab: null,
            dialog: false,
            gifts: [],
            options: {},
            entries: [],
            gift: {
                id: null,
                sum: '',
                is_active: 1,
                parcent: '',
            },
            cloneGift: {
              id: null,
              sum: '',
              is_active: 1,
              parcent: '',
            },
            footerProps: {
                itemsPerPageText: 'Элементов на страницу',
                pageText: '{0}-{1} из {2}',
                itemsPerPageAllText: 'Все',
                itemsPerPageOptions: [-1]
            },
            totalProducts: 0,
            headers: [
                {
                    text: 'Сумма',
                    value: 'sum',
                    width: '1%'
                },
                {
                    text: 'Подарок',
                    value: 'product.name',
                    width: '1%'
                },
                {
                  text: 'Активен',
                  value: 'is_active',
                  width: '1%',
                  sortable: false
                },
                {text: '', value: 'actions', sortable: false, width: "5%"},
            ],
        }),
        mounted() {
        },
        computed: {
        },
        watch: {
            options: {
                handler() {
                    this.getDataFromApi()
                },
                deep: true,
            },
            search (val) {
                // Items have already been loaded
                // if (this.entries.length > 0) return

                // Items have already been requested
                if (this.isLoading) return

                this.isLoading = true

                // Lazily load input items
                ProductService.findByName({word: this.search}).then(response => {
                  this.entries = response.data;
                }).finally(response => {
                    this.isLoading = false
                });
                // fetch('https://api.publicapis.org/entries')
                    // .then(res => res.json())
                    // .then(res => {
                    //     const { count, entries } = res
                    //     this.entries = entries
                    // })
                    // .catch(err => {
                    //     console.log(err)
                    // })
                    // .finally(() => (this.isLoading = false))
            },
        },
        methods: {
            submitDelete(item = null){
                if(item){
                    this.removeGift(item.id)
                } else {
                    // this.massDelete()
                }
            },
            removeGift(id){
                SaleService.removeGift(id).then(response => {
                    this.getDataFromApi();
                    this.loadingModal = false;
                })
            },
            createGift(){
                this.loadingModal = true;
                SaleService.createGift(this.gift).then(response => {
                    this.getDataFromApi();
                    this.loadingModal = false;
                })
            },
            updateGift(item){
                SaleService.updateGift(item.id, {sum: item.sum, products_id: item.product.id, is_active: (item.is_active ? 1 : 0)}).then(response => {
                    this.getDataFromApi();
                })
            },
            getDataFromApi() {
                this.loading = true

                SaleService.listGift({fromAdmin: true})
                    .then(response => {
                        this.gifts = response.data
                        this.loading = false
                    })
            },
        }
    }
</script>

<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }
  span.v-btn{
    border-color: currentColor!important;
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }



    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
